import HtmlCollapsibleText from './HtmlCollapsibleText'

export default HtmlCollapsibleText
